import HttpService from "../http";

const UserService = () => {
    const { httpRequest } = HttpService();

    const userProfile = (search) => new Promise((resolve, reject) => {
        httpRequest("GET", "user/v1/profile/viewProfile", {}, search)
            .then(resolve)
            .catch(reject);
    });

    const updateUser = (payload) => new Promise((resolve, reject) => {
        httpRequest("PUT", "user/v1/profile/updateprofile", payload)
            .then(resolve)
            .catch(reject);
    });


    return { userProfile, updateUser };
}

export { UserService };